import { Navigate, useLocation } from 'react-router-dom';

export default function AuthBarrier({ token, isProtected, redirectTo, children }) {
    const location = useLocation();
    const isAuthorized = !isProtected || token.parse().user.is_active;
    return isAuthorized ? children : <Navigate to={redirectTo} state={{ from: location }} />;
}
